export default __webpack_public_path__ + "static/media/builtTamato.24e5e971.png";